import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { login_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/login_template";
import {vnApp_sentinelbi} from "../components/vnApp_sentinelbi";

declare var page: any;
declare var ko: any;

export class login extends vnModule_knockoutJS{

    protected loginTemplate: login_template;
    protected requestedUrl:  string;

    protected getModuleName(){
        return "login";
    }

    buildContent() : Array<Element>{

        let vnApp : vnApp_sentinelbi = <vnApp_sentinelbi>this.getVnAppZone().app;

        if(vnApp.loggedUser.isLoggedIn) {

            let redirectUrl = '/';

            for (var i = this.vnAppZone.app.routeHistory.length - 1; i >= 0; i--) {

                if (this.vnAppZone.app.routeHistory[i] != "/" && this.vnAppZone.app.routeHistory[i] != "/login" && this.vnAppZone.app.routeHistory[i].indexOf('/reset/accountName/') === -1 ) {

                    redirectUrl = this.vnAppZone.app.routeHistory[i];
                    break;
                }
            }

            page.redirect(redirectUrl);
        }

        this.loginTemplate = new login_template("loginForm", this.viewModel, this);

        let loginMessage = "<p class=\"form-text\">Have any questions or need help?<br>Our support team is always happy to assist!<br /><a href=\"mailto:support@sentinelpro.com\">support@sentinelpro.com</a></p>";
        this.loginTemplate.setLoginMessage(loginMessage);

        let loginTitle = "<h3 class=\"form-title logo logo-color\" style=\"text-transform: none;font-size: 1.25rem;\">Log In To SentinelPro</h3>";
        this.loginTemplate.setLoginTitle(loginTitle);

        let loginFooter = "<footer class=\"default-footer\"><span class=\"logo-short\"></span><span class=\"footer-text\">©" + new Date().getFullYear() + " ValServ Inc. All rights reserved.</span><span>|</span><a href=\"https://sentinelpro.com/pages/privacy-policy\" target=\"_blank\">Privacy Policy</a></footer>";
        this.loginTemplate.setLoginFooter(loginFooter);

        let accountName = this.getAccountNameFromSubdomain(window.location.host);

        if (accountName) {

            this.loginTemplate.setAccountField(false);
            this.loginTemplate.setAccountName(accountName);
        } else {

            let noAccount = "<p class=\"form-text\">Don't have an account? <a onclick=\"window.location.assign('https://sentinelpro.com/pages/pricing')\">Register instead</a>.</p>";
            this.loginTemplate.setNoAccount(noAccount);

            // enable the account field on the login screen
            this.loginTemplate.setAccountField(true);
            this.loginTemplate.setLoginFields(false);
            accountName = localStorage.getItem('accountName');

            if (accountName) {
                this.loginTemplate.setAccountName(accountName);
            }
        }

        return [this.loginTemplate.build()];
    }

    // template event
    public redirectToLogin(){
        page.redirect('/');
    }

    // template event
    protected onSubmitLoginForm() {

        let accountName = this.getAccountNameFromSubdomain(window.location.host);

        if (!accountName) {

            this.accountRedirect()
        } else {

            this.login()
        }
    }

    protected accountRedirect(){

        this.requestedUrl = window.location.pathname;
        let loginReq_url: string = '/api/access/accountValidation/';
        let loginReq_Params: Array<Array<string>> = [];
        loginReq_Params.push( ["data", ko.toJSON(this.viewModel["loginForm"])] );

        let submittedAcc = this.viewModel['loginForm'].a;

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(loginReq_url,loginReq_Params, this);
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function(){

                obj.manageResponse(req, obj, function (){

                    let responseParsed = JSON.parse(req.request.response);

                    //redirect to the proper subdomain
                    var properDomain = 'sentinelpro.com';

                    if (window.location.host.includes('staging.' + properDomain)) {

                        properDomain = "staging." + properDomain;
                    }else if(window.location.host.includes('ads.' + properDomain)) {

                        properDomain = "ads." + properDomain;
                    }

                    var localEnv = "";
                    var env = window.location.host.split(properDomain);
                    if (env.length == 2) {

                        localEnv = env[1];
                    }

                    window.location.assign('https://' + responseParsed.accountName + '.' + properDomain + localEnv + '/login');
                });
            }
        });
        XHRHdl.execute();
    }// template event

    protected login(){

        this.requestedUrl = window.location.pathname;
        let loginReq_url: string = '/api/access/login/';
        let loginReq_Params: Array<Array<string>> = [];
        loginReq_Params.push( ["data", ko.toJSON(this.viewModel["loginForm"])] );

        let submittedAcc = this.viewModel['loginForm'].a;

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(loginReq_url,loginReq_Params, this);
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function(){

                obj.manageResponse(req, obj, function (){

                    let responseParsed = JSON.parse(req.request.response);

                    let actualModule = (<login>obj);
                    if(  req.request.status == 200  ){

                        // 2fa
                        if (responseParsed.twoFaNeeded && responseParsed.user != null) {
                            actualModule.loginTemplate.enableTwoFactorVerification(true, responseParsed.user.id, responseParsed.user.dateTwoFactorExpires);
                            return; 
                        }

                        let { redirectUrl, queryString } = actualModule.getRedirectUrlWithQuery();
                    
                        page.redirect(redirectUrl + queryString);
                    }
                    else{

                        actualModule.onUpdateError(req.request.status, responseParsed)
                    }

                    let redirectUrl = '/';

                    for (var i = obj.vnAppZone.app.routeHistory.length - 1; i >= 0; i--) {

                        if (obj.vnAppZone.app.routeHistory[i] != "/" && obj.vnAppZone.app.routeHistory[i] != "/login" && obj.vnAppZone.app.routeHistory[i].indexOf('/reset/accountName/') === -1 ) {

                            redirectUrl = obj.vnAppZone.app.routeHistory[i];
                            break;
                        }
                    }

                    // if login success, set the account name in local storage for quicker login next time.
                    localStorage.setItem('accountName', submittedAcc);

                    page.redirect(redirectUrl);
                });
            }
        });
        XHRHdl.execute();
    }

    public onSwitchAccount(){

        const subDomain = this.getAccountNameFromSubdomain(window.location.host);

        if(subDomain) {

            let url = "https://" + window.location.host.replace(subDomain + ".", '') + "/login"
            window.location.assign(url);
        }
    }

    // template event
    public retrievePassword(){

        let loginReq_url: string = '/api/access/retrievepassword/';
        let loginReq_Params: Array<Array<string>> = [];
        loginReq_Params.push( ["data", ko.toJSON(this.viewModel["loginForm"])] );
        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(loginReq_url,loginReq_Params, this);
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function(){

                obj.manageResponse(req, obj, function (){

                    let actualModule = (<login>obj);

                    actualModule.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Please verify your inbox, we have sent you an email with instructions on how to reset your password.");
                    page.redirect('/login');
                });
            }
        });
        XHRHdl.execute();
    }



    protected onUpdateError(requestStatus: any, responseParsed) : void{

        this.loginTemplate.setError(responseParsed);
    }

    private getAccountNameFromSubdomain(url: string) {

        try {

            //redirect to the proper subdomain
            var properDomain = 'sentinelpro.com';

            var hostnameParts = url.split('.' + properDomain);

            // Check if there are two parts extracted
            if (hostnameParts.length === 2 && !this.isAccountNameBanned(hostnameParts[0])) {

                var accountHostnameParts = hostnameParts[0].split('.');

                if (accountHostnameParts.length == 2) {

                    if (this.isAccountNameBanned(accountHostnameParts[1])) {

                        return accountHostnameParts[0];
                    } else {

                        return hostnameParts[0];
                    }
                }else {

                    return accountHostnameParts[0];
                }
            }
            // Return null if there is no subdomain
            return null;
        } catch (error) {
            return null;
        }
    }

    private isAccountNameBanned(accountName){
        const bannedAccountNames = [
            'ads', 'staging'
        ]

        return bannedAccountNames.includes(accountName);
    }

    public async onSubmitOtpForm(): Promise<void> {
        try {
            let fullOtpCode = this.viewModel.loginForm.getFullOtpCode();
            const otpReqPayload = {
                data: JSON.stringify({
                    a: this.viewModel.loginForm.a,
                    userId: this.viewModel.loginForm.userId(),
                    otpCode: fullOtpCode
                })
            };
    
            const response = await fetch("/api/access/verify-otp/", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(otpReqPayload),
            });
    
            const responseParsed = await response.json();
    
            if (response.ok) {
                if (responseParsed.success) {
                    this.loginTemplate.getTemplateViewModel().otpSuccessMessage("Two-Factor Authentication Success.");
                    this.loginTemplate.getTemplateViewModel().otpFailureMessage("");
                    
                    let { redirectUrl, queryString } = this.getRedirectUrlWithQuery();
                    page.redirect(redirectUrl + queryString);
                } else {
                    this.loginTemplate.getTemplateViewModel().otpFailureMessage(responseParsed.message || "Two-Factor Authentication has Failed.");
                    this.loginTemplate.getTemplateViewModel().otpSuccessMessage("");
    
                    if (responseParsed.disableVerify) {
                        this.loginTemplate.disableVerify(true);
                    }
                }
            } else {
                this.loginTemplate.getTemplateViewModel().otpFailureMessage(responseParsed.message || "Two-Factor Authentication has Failed.");
                this.loginTemplate.getTemplateViewModel().otpSuccessMessage("");
    
                if (responseParsed.disableVerify) {
                    this.loginTemplate.disableVerify(true);
                }
            }
        } catch (error) {
            this.loginTemplate.getTemplateViewModel().otpFailureMessage("An unexpected error occurred.");
            this.loginTemplate.getTemplateViewModel().otpSuccessMessage("");
        }
    }
    
    public async onResendOtpCode(): Promise<void> {
        try {
            const resendReqPayload = {
                data: JSON.stringify({
                    a: this.viewModel.loginForm.a,
                    userId: this.viewModel.loginForm.userId(),
                    currentHost: this.viewModel.loginForm.currentHost()
                })
            };
    
            const response = await fetch("/api/access/resend-otp/", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(resendReqPayload),
            });
    
            const responseParsed = await response.json();
    
            if (response.ok && responseParsed.otpExpiryDate) {
                this.loginTemplate.getTemplateViewModel().otpSuccessMessage(responseParsed.message);
                this.loginTemplate.getTemplateViewModel().otpFailureMessage("");
                this.loginTemplate.setIs2FaVerifyDisabled(false);
                this.loginTemplate.setDateTwoFactorExpires(responseParsed.otpExpiryDate);
            } else if (response.status === 429) {
                if (responseParsed.message) {
                    this.loginTemplate.getTemplateViewModel().otpFailureMessage(responseParsed.message || "Resending Two-Factor Authentication has Failed.");
                    this.loginTemplate.getTemplateViewModel().otpSuccessMessage("");
                }
                this.loginTemplate.setIsResendDisabled(true);
                setTimeout(() => {
                    this.loginTemplate.setIsResendDisabled(false);
                }, 60000); 
            } else if (response.status === 403) {
                if (responseParsed.message) {
                    this.loginTemplate.getTemplateViewModel().otpFailureMessage(responseParsed.message || "Resending Two-Factor Authentication has Failed.");
                    this.loginTemplate.getTemplateViewModel().otpSuccessMessage("");
                }
                if (responseParsed.disableResend) {
                    this.loginTemplate.setIsResendDisabled(true);
                }
                if (responseParsed.disableCountDown) {
                    this.loginTemplate.setIsCountdownDisabled(true);
                }
            } else {
                this.loginTemplate.getTemplateViewModel().otpFailureMessage(responseParsed.message || "Resending Two-Factor Authentication has Failed.");
                this.loginTemplate.getTemplateViewModel().otpSuccessMessage("");

                if (responseParsed.disableResend) {
                    this.loginTemplate.setIsResendDisabled(true);
                }
                if (responseParsed.disableCountDown) {
                    this.loginTemplate.setIsCountdownDisabled(true);
                }
            }
        } catch (error) {
            this.loginTemplate.getTemplateViewModel().otpFailureMessage("An unexpected error occurred.");
            this.loginTemplate.getTemplateViewModel().otpSuccessMessage("");
        }
    }

    private getRedirectUrlWithQuery(): { redirectUrl: string; queryString: string } {
        let defaultUrl = "/";
        let queryString = window.location.search || "";
    
        for (let i = this.vnAppZone.app.routeHistory.length - 1; i >= 0; i--) {
            let route = this.vnAppZone.app.routeHistory[i];
    
            if (route !== "/" && route !== "/login" && !route.includes("/reset/token/")) {
                return { redirectUrl: route, queryString };
            }
        }
    
        return { redirectUrl: defaultUrl, queryString };
    }
}



// WEBPACK FOOTER //
// ./js/modules/login.ts